import type { AccountKey } from 'owa-client-types';
import { isDefaultAccountKey } from 'owa-client-types';

/**
 * Maps an account key to 'globalAccount' if conditions are met.
 * Returns 'globalAccount' if the account key is:
 * - undefined
 * - 'globalAccount'
 * - a default account key
 *
 * @param accountKey The account key to map
 * @param token Optional token to check for global account mapping
 * @returns The mapped account key or 'globalAccount'
 */
export function mapToGlobalAccountKey(
    accountKey: AccountKey | 'globalAccount' | undefined
): AccountKey | 'globalAccount' {
    if (!accountKey || accountKey === 'globalAccount' || isDefaultAccountKey(accountKey)) {
        return 'globalAccount';
    }

    return accountKey;
}
